import { AppTime } from '@macs-frontend/core/utils/time';
import { UUID } from '@macs-frontend/core/utils/uuid';
import { TeamCost } from '@macs-frontend/features/company-management/team-cost/team-cost.types';
import { MdAction } from '@macs-frontend/features/shared';
import { ActionsFormEntity } from '@macs-frontend/features/actions-form-shared/models/actions-form.model';

export const emptyTeamCost: TeamCost = Object.freeze({
  uuid: '' as unknown as UUID,
  name: '',
  invoiceUuid: '' as unknown as UUID,
  description: '',
  logo: '',
  normalHours: null as unknown as AppTime,
  hasCustomActions: false,
  breakHours: null as unknown as AppTime,
  substractBreakHoursForHR: false,
  substractBreakHoursForClient: false,
  applyHolidayRates: false,
  contactCount: 0,
  compositionReservePercentage: 0,
  extraCost: undefined,
  billablePrice: 0,
  margin: 0,
  unitPrice: 0,
  ccBillable: undefined,
  ccMargin: undefined,
  ccReal: undefined,
  targetContacts: undefined,
  totalContactsVal: undefined,
  totalContactsPercent: undefined,
  budgetVal: undefined,
  budgetPercent: undefined,
  actions: undefined,
  totalCost: undefined,
  totalActions: undefined,
  realActionsQty: undefined,
  realTeamCost: undefined,
  isCustom: false,
  customNumber: undefined,
  compositionRolesTotalBillablePrice: undefined,
  compositionRolesTotalUnitPrice: undefined,
  servicesTotalBillablePrice: undefined,
  servicesTotalUnitPrice: undefined,
  transportsTotalBillablePrice: undefined,
  transportsTotalUnitPrice: undefined,
  startDate: undefined,
  endDate: undefined,
  startDateUTC: undefined,
  endDateUTC: undefined,
  viaCompanyStartDate: undefined,
  viaCompanyEndDate: undefined,
  viaCompanyStartDateUTC: undefined,
  viaCompanyEndDateUTC: undefined,
  directToEventStartDate: undefined,
  directToEventEndDate: undefined,
  directToEventStartDateUTC: undefined,
  directToEventEndDateUTC: undefined,
  materialGroups: [],
  materialGroupItems: [],
  services: [],
  tasks: [],
  transports: [],
  scheduleStartLocations: [],
  scheduleAssignments: [],
  compositionRoles: [],
  ratesheet: undefined,
  availableViaCompanies: [],
  actionUuid: null,
  action: null as unknown as MdAction,
  materialFiles: [],
  readOnlyConstraints: {
    messages: [],
    bookedRoles: [],
    childActions: [],
    hasConstraints: false,
    bookedTransports: [],
  },
  projectedSamples: null,
  projectedContacts: null,
  actionsCount: 0,
  debriefing: null as unknown as ActionsFormEntity,
  companyForm: null as unknown as ActionsFormEntity,
  clientForm: null as unknown as ActionsFormEntity,
});
